import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, DollarSign, Users, TrendingUp } from 'lucide-react';
import { Button } from '../../components/ui/Button';
export function Omnicredit() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="w-full pt-24 pb-24 bg-engage-black min-h-screen" data-id="element-344">
      <div className="max-w-6xl mx-auto px-4" data-id="element-345">
        {/* Back Link */}
        <Link to="/case-studies" className="inline-flex items-center text-engage-gray4 hover:text-engage-yellow transition-colors mb-12 font-medium" data-id="element-346">
          <ArrowLeft className="w-4 h-4 mr-2" data-id="element-347" />
          Back to Case Studies
        </Link>

        {/* Hero */}
        <div className="mb-16 max-w-4xl" data-id="element-348">
          <div className="flex flex-wrap gap-3 mb-6" data-id="element-349">
            <span className="px-4 py-1.5 bg-engage-yellow/10 text-engage-yellow border border-engage-yellow/20 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-350">
              Financial Services
            </span>
            <span className="px-4 py-1.5 bg-engage-gray2 text-engage-gray5 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-351">
              Lead Gen
            </span>
            <span className="px-4 py-1.5 bg-engage-gray2 text-engage-gray5 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-352">
              Paid Social
            </span>
          </div>
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-black text-engage-white tracking-tight mb-4" data-id="element-353">
            Omnicredit
          </h1>
          <h2 className="text-2xl md:text-3xl text-engage-gray4 font-medium leading-tight" data-id="element-354">
            From Zero to $40K/Month in 4 Months
          </h2>
        </div>

        {/* Key Results Stats */}
        <div className="mb-16" data-id="element-355">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-356">
            <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 relative overflow-hidden group hover:border-engage-yellow/50 transition-colors" data-id="element-357">
              <div className="absolute top-0 right-0 p-6 opacity-5 group-hover:opacity-10 transition-opacity" data-id="element-358">
                <DollarSign className="w-24 h-24 text-engage-yellow" data-id="element-359" />
              </div>
              <div className="relative z-10 flex flex-col h-full justify-between" data-id="element-360">
                <div className="w-12 h-12 bg-engage-black border border-engage-gray2 rounded-xl flex items-center justify-center mb-6" data-id="element-361">
                  <DollarSign className="w-6 h-6 text-engage-yellow" data-id="element-362" />
                </div>
                <div data-id="element-363">
                  <div className="text-4xl md:text-5xl font-black text-engage-white mb-2 tracking-tight" data-id="element-364">
                    $40K
                  </div>
                  <div className="text-engage-gray4 font-medium uppercase tracking-wider text-sm" data-id="element-365">
                    Monthly Revenue
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 relative overflow-hidden group hover:border-engage-yellow/50 transition-colors" data-id="element-366">
              <div className="absolute top-0 right-0 p-6 opacity-5 group-hover:opacity-10 transition-opacity" data-id="element-367">
                <Users className="w-24 h-24 text-engage-yellow" data-id="element-368" />
              </div>
              <div className="relative z-10 flex flex-col h-full justify-between" data-id="element-369">
                <div className="w-12 h-12 bg-engage-black border border-engage-gray2 rounded-xl flex items-center justify-center mb-6" data-id="element-370">
                  <Users className="w-6 h-6 text-engage-yellow" data-id="element-371" />
                </div>
                <div data-id="element-372">
                  <div className="text-4xl md:text-5xl font-black text-engage-white mb-2 tracking-tight" data-id="element-373">
                    0 to 100+
                  </div>
                  <div className="text-engage-gray4 font-medium uppercase tracking-wider text-sm" data-id="element-374">
                    Daily Leads
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 relative overflow-hidden group hover:border-engage-yellow/50 transition-colors" data-id="element-375">
              <div className="absolute top-0 right-0 p-6 opacity-5 group-hover:opacity-10 transition-opacity" data-id="element-376">
                <TrendingUp className="w-24 h-24 text-engage-yellow" data-id="element-377" />
              </div>
              <div className="relative z-10 flex flex-col h-full justify-between" data-id="element-378">
                <div className="w-12 h-12 bg-engage-black border border-engage-gray2 rounded-xl flex items-center justify-center mb-6" data-id="element-379">
                  <TrendingUp className="w-6 h-6 text-engage-yellow" data-id="element-380" />
                </div>
                <div data-id="element-381">
                  <div className="text-4xl md:text-5xl font-black text-engage-white mb-2 tracking-tight" data-id="element-382">
                    4x
                  </div>
                  <div className="text-engage-gray4 font-medium uppercase tracking-wider text-sm" data-id="element-383">
                    ROAS
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Content Sections */}
        <div className="space-y-10" data-id="element-384">
          {/* The Challenge */}
          <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 md:p-12" data-id="element-385">
            <h3 className="text-2xl md:text-3xl font-bold text-engage-white mb-3" data-id="element-386">
              The Challenge
            </h3>
            <div className="w-16 h-1 bg-engage-yellow rounded-full mb-6" data-id="element-387" />
            <p className="text-engage-gray4 text-base md:text-lg leading-relaxed" data-id="element-388">
              OmniCredit entered the market with no existing growth
              infrastructure{'\u2014'}no revenue history, no validated digital
              acquisition system, and no funnel in place to consistently
              generate or convert demand. Like many early-stage financial
              brands, the challenge wasn{'\u2019'}t just attracting attention,
              but doing so with enough clarity, trust, and precision to bring
              qualified leads into the business. The goal was not simply to
              launch fast, but to build the right system from day one.
            </p>
          </div>

          {/* Our Approach & The Result */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-389">
            <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 md:p-10 relative overflow-hidden" data-id="element-390">
              <div className="absolute top-0 right-0 w-40 h-40 bg-[radial-gradient(circle_at_top_right,rgba(252,198,13,0.12)_0%,transparent_70%)]" data-id="element-391" />
              <div className="relative z-10" data-id="element-392">
                <h3 className="text-2xl md:text-3xl font-bold text-engage-white mb-3" data-id="element-393">
                  Our Approach
                </h3>
                <div className="w-16 h-1 bg-engage-yellow rounded-full mb-6" data-id="element-394" />
                <p className="text-engage-gray4 text-base md:text-lg leading-relaxed" data-id="element-395">
                  We developed a full marketing strategy, defining the avatar,
                  positioning, and overall plan. From there, we created
                  high-performing content aligned with that strategy, launched
                  Meta ads, and implemented a proven funnel system optimized for
                  conversion.
                </p>
              </div>
            </div>
            <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 md:p-10 relative overflow-hidden" data-id="element-396">
              <div className="absolute top-0 right-0 w-40 h-40 bg-[radial-gradient(circle_at_top_right,rgba(252,198,13,0.12)_0%,transparent_70%)]" data-id="element-397" />
              <div className="relative z-10" data-id="element-398">
                <h3 className="text-2xl md:text-3xl font-bold text-engage-white mb-3" data-id="element-399">
                  The Result
                </h3>
                <div className="w-16 h-1 bg-engage-yellow rounded-full mb-6" data-id="element-400" />
                <p className="text-engage-gray4 text-base md:text-lg leading-relaxed" data-id="element-401">
                  Within the first month, results came in almost
                  immediately—high-quality leads started flowing in and deals
                  began closing consistently. In just 90 days, Omnicredit scaled
                  from $0 to $40K/month in revenue, powered by the Engage
                  Machine and a system built to generate and convert demand.
                </p>
              </div>
            </div>
          </div>

          {/* Testimonial */}
          <div className="bg-engage-gray1 border border-engage-gray2 p-10 md:p-16 lg:p-20 rounded-2xl relative overflow-hidden text-center" data-id="element-402">
            <div className="flex justify-center mb-8" data-id="element-403">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" className="text-engage-yellow" data-id="element-404">
                <path d="M14.017 21L16.411 14.182C16.411 14.182 15.045 14.182 15.045 10.773C15.045 7.36364 18.006 5 21 5C23.994 5 24 7.36364 24 7.36364C24 7.36364 22.634 7.36364 22.634 10.773C22.634 14.182 19.909 21 19.909 21H14.017ZM3.017 21L5.411 14.182C5.411 14.182 4.045 14.182 4.045 10.773C4.045 7.36364 7.006 5 10 5C12.994 5 13 7.36364 13 7.36364C13 7.36364 11.634 7.36364 11.634 10.773C11.634 14.182 8.909 21 8.909 21H3.017Z" data-id="element-405" />
              </svg>
            </div>
            <blockquote className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-medium italic text-engage-white mb-10 md:mb-12 leading-relaxed relative z-10 max-w-4xl mx-auto" data-id="element-406">
              We didn{'\u2019'}t just launch{'\u2014'}we built a system that
              generates revenue consistently. From zero to a real acquisition
              engine in months.
            </blockquote>
            <div className="flex flex-col items-center relative z-10" data-id="element-407">
              <img src="https://cdn.magicpatterns.com/uploads/dPAfToJ51mhUvjXGJW51v5/Omnicredit-CS.png" alt="Omnicredit" className="w-16 h-16 md:w-20 md:h-20 rounded-full mb-4 border-2 border-engage-gray2 object-cover" data-id="element-408" />
              <div className="font-bold text-engage-white text-lg" data-id="element-409">
                OmniCredit Team
              </div>
              <div className="text-engage-yellow font-medium text-sm uppercase tracking-wider" data-id="element-410">
                CEO, OmniCredit
              </div>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="mt-20 text-center bg-engage-gray1 border border-engage-gray2 rounded-2xl p-12 md:p-20 relative overflow-hidden" data-id="element-411">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(252,198,13,0.08)_0%,transparent_100%)]" data-id="element-412" />
          <div className="relative z-10 max-w-4xl mx-auto" data-id="element-413">
            <h2 className="text-3xl md:text-5xl font-black mb-6 tracking-tight" data-id="element-414">
              Ready to Build Your Growth Engine?
            </h2>
            <p className="text-engage-gray4 text-xl mb-10" data-id="element-415">
              Stop guessing with your marketing budget. Let's build a
              predictable system for your brand.
            </p>
            <Button to="/contact" variant="primary" className="text-lg px-12 py-5" data-id="element-416">
              Book a Call With Us
            </Button>
          </div>
        </div>
      </div>
    </div>;
}